import axios from 'core/api'
import { BaseResponse, RequestConfig } from 'common/types/api'
import { ProductByMedicine } from './types'

export const MEDICINE_REQUEST_CONFIG: RequestConfig = {
  get: { method: 'GET', url: '/medicine' },
  getPieChart: { method: 'GET', url: '/medicine/pie-chart' },
  getRecent: { method: 'GET', url: '/medicine/recent' },
  getName: { method: 'GET', url: '/medicine/name' },
  createName: { method: 'POST', url: '/medicine/name' },
  create: { method: 'POST', url: '/medicine' },
  edit: { method: 'PATCH', url: '/medicine' },
  delete: { method: 'DELETE', url: '/medicine' },
  getSummaryToday: { method: 'GET', url: '/medicine/summary' },
  createProduct: { method: 'POST', url: '/product/medicine' },
  createMedicineByProduct: { method: 'POST', url: '/medicine/product' },
}

export const getListProductByMedicine = (farmId: string, pondId: string, cycleId: string) =>
  axios.get<BaseResponse<ProductByMedicine[]>>(
    `/farms/${farmId}/ponds/${pondId}/cycles/${cycleId}/medicine/product/list`
  )
